module.exports = __webpack_public_path__ + "media/images/icons/country_flags/mf-9284dddffc0b6717ee5fd113cfe2aad8.svg";